export default __webpack_public_path__ + "static/media/dance.38d7f573.png";